import { render } from "./UpgradeOptions.vue?vue&type=template&id=35ddd6ae&scoped=true"
import script from "./UpgradeOptions.vue?vue&type=script&lang=js"
export * from "./UpgradeOptions.vue?vue&type=script&lang=js"

import "./UpgradeOptions.vue?vue&type=style&index=0&id=35ddd6ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ddd6ae"]])

export default __exports__